import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { View } from "../components/base";

export const IndexPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/agents");
  }, []);

  return <View />;
};
